import { useState } from 'react'

import { Alert, Col, Form, Row } from 'react-bootstrap'
import { Diagram3Fill } from 'react-bootstrap-icons'

import { Center } from '../../../../../components/Center'
import { CustomButton } from '../../../../../components/CustomButton'
import { CustomIntegerInput } from '../../../../../components/CustomDecimalInput'
import { Ghost } from '../../../../../components/Ghost'

import WmsInventarioService from '../../../../../services/database/WmsInventarioService'

import { sendErrorApiMessage } from '../../../../../utils/sendErrorApiMessage'

import Swal from 'sweetalert2'
import { ComponentContainer, ComponentContent } from '../../styles'

export function Division({ inventory, setInventory, onNext }) {
  /**
   *! D = Depósito
   *! DR = Depósito/Rua
   *! DRL = Depósito/Rua/Lado
   *! DRN = Depósito/Rua/Nível
   *! DRLN = Depósito/Rua/Lado/Nível
   */

  const [tipo_quebra, setTipoQuebra] = useState('D')
  const [isGenerateBreakLoading, setIsGenerateBreakLoading] = useState(false)
  const [dividir_picking_pulmao, setDividirPickingPulmao] = useState(false)
  const [quantidade_maxima_predios, setQuantidadeMaximaPredios] = useState('')

  async function handleGenerateBreak() {
    try {
      setIsGenerateBreakLoading(true)

      const responseMessage = await WmsInventarioService.generateBreak({
        enderecos: inventory.addresses,
        tipo_quebra,
        dividir_picking_pulmao,
        quantidade_maxima_predios,
        inventario_id: inventory.info.id,
      })

      setInventory((prevState) => ({
        ...prevState,
        isDivisionConfirmed: true,
      }))

      Swal.fire({
        title: 'Operação concluída com sucesso!',
        text: `A operação demorou ${responseMessage}`,
        icon: 'success',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: 'Ok',
      }).then((result) => {
        if (result.isConfirmed) {
          onNext()
        }
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível gerar a quebra!')
    } finally {
      setIsGenerateBreakLoading(false)
    }
  }

  return (
    <>
      <ComponentContainer>
        <ComponentContent>
          <p>
            Divida as ordens de serviços de acordo com os critérios desejados.
          </p>

          <Ghost isVisible={inventory.addresses.length === 0}>
            <Alert variant="warning">Sem endereços confirmados.</Alert>
          </Ghost>

          <Ghost isVisible={inventory.addresses.length > 0}>
            <p>Tipo de Quebra</p>
            <Row>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 20,
                }}
              >
                <Form.Check
                  label="Depósito"
                  checked={tipo_quebra === 'D'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTipoQuebra('D')
                    }
                  }}
                />

                <Form.Check
                  label="Depósito/Rua"
                  checked={tipo_quebra === 'DR'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTipoQuebra('DR')
                    }
                  }}
                />

                <Form.Check
                  label="Depósito/Rua/Lado"
                  checked={tipo_quebra === 'DRL'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTipoQuebra('DRL')
                    }
                  }}
                />

                <Form.Check
                  label="Depósito/Rua/Nível"
                  checked={tipo_quebra === 'DRN'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTipoQuebra('DRN')
                    }
                  }}
                />

                <Form.Check
                  label="Depósito/Rua/Lado/Nível"
                  checked={tipo_quebra === 'DRLN'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTipoQuebra('DRLN')
                    }
                  }}
                />
              </div>
            </Row>
            <Row className="my-3">
              <Col>
                <Form.Check
                  label="Dividir OS para o picking e pulmão"
                  checked={dividir_picking_pulmao}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setDividirPickingPulmao(true)
                    } else {
                      setDividirPickingPulmao(false)
                    }
                  }}
                />
              </Col>

              <Col>
                <Form.Label>Quantidade máxima de prédios por O.S</Form.Label>
                <CustomIntegerInput
                  value={quantidade_maxima_predios}
                  onChange={(e) => setQuantidadeMaximaPredios(e.target.value)}
                />
              </Col>
            </Row>
            <Alert variant="danger">
              Essa ação pode demorar alguns minutos, tenha certeza de que está
              pronto para prosseguir. Uma vez iniciada essa ação, ela não pode
              ser desfeita ou cancelada.
            </Alert>

            <Center jc="flex-start">
              <CustomButton
                title="Gerar Quebra"
                noMargin
                className="mt-3"
                onClick={handleGenerateBreak}
                isLoading={isGenerateBreakLoading}
                isLoadingText="Gerando Quebra..."
              >
                <Diagram3Fill />
              </CustomButton>
            </Center>
          </Ghost>
        </ComponentContent>
      </ComponentContainer>
    </>
  )
}
